module.exports = {
    "collapse": `Skjul`,
    "expand": `Utvid`
};


//# sourceMappingURL=nb-NO.main.js.map
